export const generateRounds = (playersCount = 4) => {
  const players = Array.from({ length: playersCount }, (_, i) => ({
    id: `P${i + 1}`,
    name: `Jugador ${i + 1}`,
    score: 0,
  }))

  const rounds = []
  const currentRound = []

  for (let i = 0; i < players.length; i += 2) {
    currentRound.push({
      player1: players[i],
      player2: players[i + 1],
    })
  }
  rounds.push(currentRound)

  let matches = currentRound.length
  while (matches > 1) {
    matches = matches / 2
    rounds.push(
      Array.from({ length: matches }, () => ({
        player1: { id: crypto.randomUUID(), name: "Pendiente", score: 0 },
        player2: { id: crypto.randomUUID(), name: "Pendiente", score: 0 },
      })),
    )
  }

  return rounds
}
